import { motion } from 'framer-motion';

interface Props {
  visible: boolean;
  color?: string;
}

export default function PreparingIndicator({ visible, color = 'rgba(255,255,255,0.6)' }: Props) {
  if (!visible) return null;
  return (
    <motion.div
      className="absolute inset-0 z-40 flex items-center justify-center pointer-events-none"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.6 }}
    >
      <motion.p
        className="text-sm tracking-[0.2em] uppercase font-serif"
        style={{ color }}
        animate={{ opacity: [0.4, 1, 0.4] }}
        transition={{ duration: 2, repeat: Infinity, ease: 'easeInOut' }}
      >
        Preparing something special…
      </motion.p>
    </motion.div>
  );
}
